import { applyLandingBrand } from "@/lib/siteHosts"

export const notForContent = applyLandingBrand({
  title: "Who FractoLabs Is NOT For",
  body: "We built this infrastructure for active roofers. FractoLabs is likely not the right fit for your business if:",
  items: [
    {
      label: "Do NOT deploy this if",
      title: "You handle fewer than 5 inbound leads per month.",
      detail: "If your lead volume is near zero, an instant-response algorithm won't yield a measurable ROI.",
    },
    {
      label: "Do NOT deploy this if",
      title: "Your team already replies to 100% of leads in under 60 seconds, 24/7/365.",
      detail: "If your speed-to-lead is already locked down, you don't need our infrastructure.",
    },
    {
      label: "Do NOT deploy this if",
      title: "Your business relies 100% on door-knocking or B2B subcontracting.",
      detail: "If you have zero digital inquiries, there is no lead flow to rescue.",
    },
  ],
})
